import { render, staticRenderFns } from "./Joinus.vue?vue&type=template&id=f5954804&scoped=true&"
import script from "./Joinus.vue?vue&type=script&lang=js&"
export * from "./Joinus.vue?vue&type=script&lang=js&"
import style0 from "./Joinus.vue?vue&type=style&index=0&id=f5954804&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5954804",
  null
  
)

export default component.exports